module.exports = __webpack_public_path__ + "static/media/logo-eryx.76f49548.svg";